/** Effect that focuses and selects a task after it is added to the list. */
import { useEffect } from 'react';

export function useNewTaskAddedEffect({
  newlyAddedTask,
  setNewlyAddedTask,
  selectSingleTask,
  taskListRef,
  newTaskSessionRef,
  cancelNewTaskInputRef,
}) {
  useEffect(() => {
    if (newlyAddedTask) {
      if (newTaskSessionRef?.current === newlyAddedTask.session) {
        taskListRef.current?.focus?.({ preventScroll: true });
        selectSingleTask(newlyAddedTask.id);
        cancelNewTaskInputRef?.current?.();
      }
      setNewlyAddedTask(null);
    }
  }, [
    newlyAddedTask,
    selectSingleTask,
    taskListRef,
    newTaskSessionRef,
    cancelNewTaskInputRef,
    setNewlyAddedTask,
  ]);
}
